import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=ddd7f2a4&"
import script from "./Accueil.vue?vue&type=script&lang=ts&"
export * from "./Accueil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports